import { useAuthStore } from "../../store/authStore";

interface RequireOrgRoleProps {
  children: React.ReactNode;
  roles?: string[];
  fallback?: React.ReactNode;
}

/**
 * Renders children only if the user has one of the specified org roles.
 * For owner/admin, access is always granted.
 */
export function RequireOrgRole({
  children,
  roles,
  fallback = null,
}: RequireOrgRoleProps) {
  const user = useAuthStore((s) => s.user);
  const orgRole = user?.org_role;

  // If no roles specified, allow owner/admin only
  const allowedRoles = roles || ["owner", "admin"];

  if (!orgRole || !allowedRoles.includes(orgRole)) {
    return <>{fallback}</>;
  }

  return <>{children}</>;
}
